import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import React from 'react';
import { StackedBarChart } from 'bizcharts';
import { Box } from "@mui/system";
import DownloadButton from "../Common/DownloadButton";

const HorizontalBarChart = (props) => {

    const [data, setData] = useState(undefined);

    const csv = props.csv;
    const { readString } = usePapaParse();

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                if (props.transform) {
                    const transformedData = [];
                    setData((prevState) => {
                        results.data.forEach(d => {
                            transformedData.push({
                                country: d['Countries'],
                                region: 'Domestic',
                                value: d['Domestic']
                            })
                            transformedData.push({
                                country: d['Countries'],
                                region: 'EU',
                                value: d['EU']
                            })
                            transformedData.push({
                                country: d['Countries'],
                                region: 'Third Country',
                                value: d['Third Country']
                            })
                            transformedData.push({
                                country: d['Countries'],
                                region: 'Unknown',
                                value: d['Unknown']
                            })
                        })
                        return transformedData.reverse();
                    })
                } else {
                    setData(results.data.sort((a, b) => a['Pesticide region'] < b['Pesticide region'] ? 1 : -1));
                }
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, []);

    const [canvas, setCanvas] = useState(undefined);

    return (
        <Box>
            <Box display='flex' justifyContent='space-between'>
                <p style={{ fontFamily: 'Roboto Condensed, sans-serif', marginBottom: '.5rem' }}>{props.title}</p>
                <Box>
                    <DownloadButton canvas={canvas} fileName={props.title} csv={data} isRaw />
                </Box>
            </Box>

            {data
                &&
                <StackedBarChart
                    onGetG2Instance={chartInstance => {
                        setCanvas(chartInstance.chart.canvas);
                    }}
                    id="StackedBarChart"
                    data={data}
                    height={650}
                    autoFit
                    legend={{ position: 'bottom', flipPage: false }}
                    yField={props.yField}
                    xField={props.xField}
                    stackField={props.stackField}
                    padding='auto'
                    color={['#246898', '#00A1C8', '#B3CEE7', '#808080']}
                    tooltip={{
                        formatter: (d) => {
                            return {
                                name: d['Pesticide region'] ? d['Pesticide region'] : d.region,
                                value: (d['Region proportion per country'] ? d['Region proportion per country'] : d.value) + '%'
                            }
                        },
                    }}
                    yAxis={{
                        label: {
                            style: {
                                fontFamily: 'Roboto Condensed, sans-serif',
                            }
                        }
                    }}
                    xAxis={{
                        label: {
                            style: {
                                fontFamily: 'Roboto Condensed, sans-serif',
                            },
                            formatter: (a, b, c) => {
                                return a + '%'
                            }
                        },
                        max: 100
                    }}
                />
            }
        </Box>
    )
};
export default HorizontalBarChart;